import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	display: flex;
	background-color: ${helpers.color.background};
	color: ${helpers.color.textLight};
	border-radius: 4px;
	column-gap: 8px;

	/* Yes this is kind of crazy and layout breaking, but that is their wish... */
	padding: 16px 36px 4px 8px;
	margin: 16px 8px;
`
